/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";

// import { useNavigate } from "react-router-dom";
import { useLiff } from "react-liff";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import correct from "../../assets/images/checkmark.png";
import TransparentButton from "../../components/button/TransparentButton";
import rightArrow from "../../assets/images/icon/right-arrow.png"; //yellow-search.png
import bingobg from "../../assets/images/bingobg.png";
import { SearchBingoCardById, InsertCardActivity } from "../../services/Bingo";
import uploadWhite from "../../assets/images/icon/upload-white.svg";
import { FormControl } from "@mui/material";
import useWindowDimensions from "../../functions/getScreen";
import CustomPopup from "../../components/popup/CustomPopup";

export default function BingoDetail() {
    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    const store = useSelector((state) => state.luckyDraw);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [bingo, setBingo] = React.useState({})
    const [image, setImage] = useState(null);
    const bg = store['bgPicture']
    const banner = store['logoPicture']
    const { width } = useWindowDimensions();
    const [openErrorImagePopup, setOpenErrorImagePopup] = React.useState(false);


    React.useEffect(() => {
        getSearchBingoDetail()
    }, []);

    async function getSearchBingoDetail() {
        return await SearchBingoCardById({ data: { bingoCardId: state.id } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setBingo(response.data.body)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleImage = (event, type) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        if (event.target.files[0].size > 5242880) {
            setOpenErrorImagePopup(true)
        } else {
            reader.onloadend = () => {
                setImage(reader.result.substring(
                    reader.result.indexOf(",") + 1
                ))
            };
            reader.readAsDataURL(file);
        }
    };

    React.useEffect(() => {
        if (image) {
            postInsertCard()
        }
    }, [image]);


    async function postInsertCard() {
        const payload =
        {
            lineId: lineId,
            bingoId: state.bingoId,
            position: bingo.position,
            picture: image
        }
        return await InsertCardActivity({ data: payload })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    navigate('/bingo-success')
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <>
            <TopLogo />
            {bingo && <div
                style={{
                    background: `url(${bg}) no-repeat center center fixed`,
                    minHeight: "calc(100vh - 60px)",
                    padding: "25px",
                    backgroundSize: "cover",
                }}
            >

                {/* <img
                    className="mt-[-25px] ml-[-25px]"
                    src={banner}
                    alt="logo"
                    style={{ width: width, maxWidth: 'none' }}
                /> */}

                <img
                    className="mx-auto mt-[140px]"
                    src={bingo.picture}
                    alt="logo"
                    style={{ width: "132px" }}
                />
                <div className="text-white text-center font-bold text-[24px]">
                    {bingo.name}
                </div>

                <div className="bg-white px-[20px] py-[20px] mt-[30px]" style={{ borderRadius: "5px" }}>
                    <div className="w-[133px] h-[31px] pt-[5px] mx-auto mt-[-40px]" style={{ borderRadius: '28px', background: 'rgba(0, 185, 241, 1)' }}>
                        <div className="flex gap-[5px] mx-auto w-fit" onClick={() => {
                            if (bingo.link) {
                                liff.openWindow({ url: bingo.link, external: false })
                            }
                        }}>
                            <p className="text-white text-[16px] mr-[5px]">ไปทำกิจกรรม</p>
                            <img
                                className="h-[10px] mt-[4px]"
                                src={rightArrow}
                                alt="logo"
                                style={{ height: '10px' }}
                            />
                        </div>
                    </div>
                    <p className="text-blue text-[20px]">กติกาการร่วมสนุก</p>
                    <p className="text blue text-[16px] whitespace-pre-line leading-[18px]"> {bingo.conditions ? bingo.conditions : '-'}</p>
                </div>

                <br></br>
                <br></br>
                <br></br>

                {state.uploadPicture &&
                    <div className="text-center">
                        <FormControl fullWidth>
                            <div className="text-center mt-[50px]">
                                <div className="w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-white border-[1px]">
                                    <img className="w-[13px]" src={uploadWhite} alt="" />
                                    <p className="text-white text-[20px]">อัปโหลดภาพกิจกรรมประจำวัน</p>
                                    <input
                                        className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                                        name="urlPicture"
                                        type="file"
                                        accept=".jpg, .jpeg, .png"
                                        onChange={(event) => handleImage(event, 'card')}
                                    />
                                </div>
                            </div>
                        </FormControl>
                        <div className="text-white text-left" style={{ fontSize: '0.8571428571428571rem' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>
                    </div>
                }
                <div className={state.uploadPicture ? "text-center" : "text-center mt-[50px]"}>
                    <div className="my-4">
                        <TransparentButton
                            variant="contained"
                            className="w-[100%]"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            ย้อนกลับ
                        </TransparentButton>
                    </div>
                </div>
            </div>
            }
            <CustomPopup
                title='รูปต้องมีขนาดไม่เกิน 5 MB'
                desc='กรุณาลองใหม่อีกครั้ง'
                cancelText="ปิด"
                cancelFunction={() => {
                    setOpenErrorImagePopup(false);
                }}
                open={openErrorImagePopup}
            />
        </>

    );
}
